import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useToast } from '../../context/ToastContext';
import { Toast, ToastType } from '../../types';

const CONFIG: Record<ToastType, { icon: React.ReactNode; bg: string; border: string; color: string }> = {
  success: { icon: <CheckCircle   size={16}/>, bg: 'rgba(34,197,94,0.12)',    border: 'rgba(34,197,94,0.25)',    color: '#22c55e' },
  error:   { icon: <XCircle       size={16}/>, bg: 'rgba(239,68,68,0.12)',    border: 'rgba(239,68,68,0.25)',    color: '#ef4444' },
  warning: { icon: <AlertTriangle size={16}/>, bg: 'rgba(234,179,8,0.12)',    border: 'rgba(234,179,8,0.25)',    color: '#eab308' },
  info:    { icon: <Info          size={16}/>, bg: 'rgba(59,130,246,0.12)',   border: 'rgba(59,130,246,0.25)',   color: '#3b82f6' },
};

function ToastItem({ toast }: { toast: Toast }) {
  const { removeToast } = useToast();
  const cfg = CONFIG[toast.type];

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 12,
      background: cfg.bg, border: `1px solid ${cfg.border}`,
      borderRadius: 12, padding: '14px 16px', minWidth: 280, maxWidth: 420,
      backdropFilter: 'blur(12px)',
      boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
      animation: 'slideUp 0.3s cubic-bezier(0.4,0,0.2,1) both',
    }}>
      <span style={{ color: cfg.color, flexShrink: 0 }}>{cfg.icon}</span>
      <span style={{ fontSize: 14, fontWeight: 400, color: 'var(--text)', flex: 1, lineHeight: 1.4 }}>
        {toast.message}
      </span>
      <button onClick={() => removeToast(toast.id)} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color: 'var(--text3)', padding: 2, borderRadius: 4,
        display: 'flex', alignItems: 'center', flexShrink: 0,
        transition: 'color 0.15s',
      }}
        onMouseEnter={e => (e.currentTarget.style.color = 'var(--text)')}
        onMouseLeave={e => (e.currentTarget.style.color = 'var(--text3)')}
      >
        <X size={14} />
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts } = useToast();
  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24, zIndex: 9999,
      display: 'flex', flexDirection: 'column', gap: 10,
      alignItems: 'flex-end', pointerEvents: 'none',
    }}>
      {toasts.map(t => (
        <div key={t.id} style={{ pointerEvents: 'auto' }}>
          <ToastItem toast={t} />
        </div>
      ))}
    </div>
  );
}
